"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlatformActivityEntryCard = exports.PlatformActivityEntryCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var person_photo_1 = require("./person-photo");
var tiny_relative_date_1 = __importDefault(require("tiny-relative-date"));
var entity_type_icon_label_1 = require("./entity-type-icon-label");
var badge_1 = require("../elements/badge");
var entity_conversation_1 = require("./entity-conversation");
var entity_activity_subject_1 = require("./entity-activity-subject");
var entity_divider_1 = require("./entity-divider");
var entity_row_1 = require("./entity-row");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('platform-activity-entry-card');
exports.PlatformActivityEntryCardDefaultProps = {
  showSourceEntity: false,
  showIndicators: false
};
// --------- Styles --------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(3)),
  landscape: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PersonContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var PersonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    color: ", ";\n    font-weight: 400;\n    b {\n      color: ", ";\n      font-weight: 500;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    color: ", ";\n    font-weight: 400;\n    b {\n      color: ", ";\n      font-weight: 500;\n    }\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.COLOR('dark'))
});
var SourceStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-grow: 1;\n    margin-bottom: ", ";\n  "], ["\n    flex-grow: 1;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var IndicatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: ", ";\n    margin-right: 2px;\n    height: 48px;\n    ", ";\n    background-position: center left;\n  "], ["\n    width: ", ";\n    margin-right: 2px;\n    height: 48px;\n    ", ";\n    background-position: center left;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG('line-mid'))
});
var PersonIndicatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    width: ", ";\n  "], ["\n    ", ";\n    width: ", ";\n  "])), IndicatorStyles, theme_1.theme.UNIT(6))
});
var PhotoAndInfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    line-height: 1.5em;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n  "], ["\n    line-height: 1.5em;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n  "])))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    padding-right: ", ";\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var WhenStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    text-transform: capitalize;\n  "], ["\n    text-transform: capitalize;\n  "])))
});
var TypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    align-items: center;\n    min-height: ", ";\n    border-top: 1px solid ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    justify-content: flex-start;\n    display: none;\n  "], ["\n    align-items: center;\n    min-height: ", ";\n    border-top: 1px solid ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    justify-content: flex-start;\n    display: none;\n  "])), theme_1.theme.UNIT(10), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2)),
  landscape: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding: 0 ", ";\n    border-top: none;\n    margin-top: 0;\n    display: flex;\n    padding-top: 0;\n    justify-content: flex-end;\n  "], ["\n    padding: 0 ", ";\n    border-top: none;\n    margin-top: 0;\n    display: flex;\n    padding-top: 0;\n    justify-content: flex-end;\n  "])), theme_1.theme.UNIT(5))
});
var DetailsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", ";\n    width: auto;\n    background: ", ";\n\n    ", "\n  "], ["\n    padding: ", ";\n    width: auto;\n    background: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(3), theme_1.theme.COLOR('app-chrome'), function (_a) {
    var showIndicators = _a.showIndicators;
    return showIndicators && (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(3, 2));
  }),
  tablet: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    ", "\n    padding: ", ";\n  "], ["\n    ", "\n    padding: ", ";\n  "])), function (_a) {
    var showIndicators = _a.showIndicators;
    return showIndicators && (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(6, 2));
  }, theme_1.theme.UNIT(4))
});
var WhenAndBadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    margin-left: ", ";\n    display: inline-block;\n    line-height: 14px;\n    height: 14px;\n  "], ["\n    margin-left: ", ";\n    display: inline-block;\n    line-height: 14px;\n    height: 14px;\n  "])), theme_1.theme.UNIT(2))
});
var ConversationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components ---------->
var My = {
  Container: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled_components_1.default.header(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Source: (0, styled_components_1.default)(entity_divider_1.EntityDivider)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), SourceStyles),
  PersonContainer: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), PersonContainerStyles),
  Indicator: styled_components_1.default.span(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), IndicatorStyles),
  PersonIndicator: styled_components_1.default.span(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), PersonIndicatorStyles),
  Person: styled_components_1.default.div(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  PhotoAndInfo: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), PhotoAndInfoStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Info: styled_components_1.default.div(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  WhenAndBadge: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), WhenAndBadgeStyles),
  When: styled_components_1.default.time(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), WhenStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Type: (0, styled_components_1.default)(entity_type_icon_label_1.EntityTypeIconLabel)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  Details: (0, styled_components_1.default)(entity_row_1.EntityRow)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  Conversation: (0, styled_components_1.default)(entity_conversation_1.EntityConversation)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ConversationStyles)
};
var PlatformActivityEntryCard = function (props) {
  var className = props.className,
    entry = props.entry,
    showSourceEntity = props.showSourceEntity,
    showIndicators = props.showIndicators;
  var person = entry.person,
    date = entry.date,
    action = entry.action,
    entity = entry.entity,
    sourceEntity = entry.sourceEntity;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity, true);
  var sourceDefinition = sourceEntity && (0, use_entity_definition_1.useEntityDefinition)(sourceEntity, true);
  if (!definition) {
    return null;
  }
  var photo = person && person.photo;
  var t = (0, use_lang_1.useLang)();
  var platformActivity = definition.platformActivity;
  var showConversation = props.showConversation === undefined ? definition.useConversation : props.showConversation;
  var componentProps = {
    t: t,
    definition: definition,
    entry: entry
  };
  var Subject = platformActivity.subjectComponent || entity_activity_subject_1.EntityActivitySubject;
  var comments = entry.comments || [];
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Header, null, sourceDefinition && showSourceEntity && sourceEntity && react_1.default.createElement(My.Source, {
    badge: "Following",
    entity: sourceEntity
  }), react_1.default.createElement(My.PersonContainer, null, showIndicators && react_1.default.createElement(My.PersonIndicator, null), react_1.default.createElement(My.Person, {
    className: cls.sub('person')
  }, react_1.default.createElement(My.PhotoAndInfo, null, person && react_1.default.createElement(My.Photo, {
    size: 48,
    link: true,
    entity: person
  }), react_1.default.createElement(My.Info, null, react_1.default.createElement(Subject, __assign({}, componentProps)), react_1.default.createElement(My.WhenAndBadge, null, date && react_1.default.createElement(My.When, null, (0, tiny_relative_date_1.default)(date)), entity.isDraft && react_1.default.createElement(My.Badge, null, t('Draft'))))))))), react_1.default.createElement(My.Details, {
    maxDescriptionLength: 500,
    showIndicators: showIndicators,
    showDescription: true,
    showFollowers: false,
    entity: entity
  }), showConversation && react_1.default.createElement(My.Conversation, {
    showInputs: false,
    anchorName: "comments-".concat(entity.slug),
    entity: entity,
    comments: comments
  }));
};
exports.PlatformActivityEntryCard = PlatformActivityEntryCard;
exports.PlatformActivityEntryCard.cls = cls;
exports.PlatformActivityEntryCard.defaultProps = exports.PlatformActivityEntryCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39;